import "../stylesheets/gallery.scss";
import Image from "./Image";

// COMPONENT

function Gallery() {
    return (
        <div className="gallery">
            <div className="images-left">
                <Image id="gallery1"/>
            </div>
            <div className="images-right">
                <div className="images-up">
                    <div className="images-up-middle">
                        <Image id="gallery2"/>
                        <Image id="gallery3"/>
                    </div>
                    <div className="images-up-right">
                        <Image id="gallery4"/>
                    </div>
                </div>
                <div className="images-down">
                    <div className="images-down-left">
                        <Image id="gallery5"/>
                    </div>
                    <div className="images-down-right">
                        <Image id="gallery6"/>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Gallery;